import { QuestionType } from '@empathy/survey/base';

export class AIResponseModel {
  chatReference: string;
  items: AIQuestion[];
}

export interface AIQuestion {
  questionId: number;
  questionText: string;
  options: string[];
  questionType: QuestionType;
  selected: boolean;
}
